/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-status[_ngcontent-%COMP%]{padding:1px 6px;cursor:default}.same-line[_ngcontent-%COMP%]{display:inline-block}"];
export { styles as styles };
